import { AutogenModelDriverPayee, AutogenRowDriverPayee } from "./autogen/AutogenModelDriverPayee";

export class ModelDriverPayee extends AutogenModelDriverPayee<RowDriverPayee> {
	constructor() {
		super(RowDriverPayee);
	}
}

export class RowDriverPayee extends AutogenRowDriverPayee {
}